import { isValidJson } from '@resider/utils';
import dictionaries from '@resider/dictionaries';

/**
 * @param {URLSearchParams} searchParams - The URL search parameters.
 * @param {{ city: string; district: string; lang: string; subdistrict: string; offer_type: string;}} params
 * @returns {import('@resider/types').ExploreFilters}
 */
export default function formatObjectFromUrlSearchParams(searchParams, params) {
	let filters = {};

	const updateFilters = (/** @type {any} */newFilters) => {
		filters = { ...filters, ...newFilters };
	};

	const arrayFilters = [
		'amenities',
		'building_type',
		'business_type',
		'city',
		'district',
		'interior_standard',
		'market',
		'price_change',
		'subdistrict'
	];

	const minmaxFilters = [
		'area',
		'build_year',
		'building_floors_num',
		'distance_to_subway',
		'floor_num',
		'inserted_at',
		'plot_area',
		'price',
		'rooms_num',
		'unit_price'
	];

	const numberFilters = ['lat', 'lon', 'max_transport_time', 'radius'];

	const stringFilters = ['description', 'destination', 'offer_type'];

	if (searchParams.has('sort_by')) {
		updateFilters({
			sort_by: `${searchParams.get('sort_by')}_${searchParams.get('asc') === '1' ? 'asc' : 'desc'}`
		});
	}

	for (const filterKey of arrayFilters) {
		if (searchParams.has(filterKey)) {
			updateFilters({
				[filterKey]: isValidJson(`${searchParams.get(filterKey)}`)
					? JSON.parse(`${searchParams.get(filterKey)}`)
					: []
			});
		}
	}

	for (const filterKey of stringFilters) {
		updateFilters({
			[filterKey]: searchParams.get(filterKey)
		});
	}

	for (const filterKey of numberFilters) {
		if (searchParams.has(filterKey)) {
			updateFilters({
				[filterKey]: Number(searchParams.get(filterKey))
			});
		}
	}

	for (const filterKey of minmaxFilters) {
		if (searchParams.has(filterKey) && isValidJson(`${searchParams.get(filterKey)}`)) {
			const filterValue = JSON.parse(`${searchParams.get(filterKey)}`);
			updateFilters({
				[filterKey]: {
					min: filterValue.min ?? null,
					max: filterValue.max ?? null
				}
			});
		}
	}

	if (params?.offer_type) {
		updateFilters({
			offer_type: params.offer_type.match(/rent|wynajem/) ? 'rent' : 'sale'
		});
	} else if (searchParams.has('offer_type')) {
		updateFilters({
			offer_type: searchParams.get('offer_type')
		});
	}

	if (params?.city) {
		updateFilters({
			city: params.city.split(',').map((/** @type {string} */x) => dictionaries.locations.cities.mazowieckie[x])
		});
	}

	if (params?.city && params?.district) {
		const districtValues = params.district.split(',');
		updateFilters({
			district: districtValues.some((/** @type {string} */x) =>
				Object.keys(dictionaries.locations.districts[params.city]).includes(x)
			)
				? districtValues.map((/** @type {string} */x) => dictionaries.locations.districts[params.city][x])
				: [],
			subdistrict: districtValues.some((/** @type {string} */x) =>
				Object.keys(dictionaries.locations.subdistricts[params.city]).includes(x)
			)
				? districtValues.map((/** @type {string} */x) => dictionaries.locations.subdistricts[params.city][x])
				: []
		});
	}

	if (params?.city && params?.subdistrict) {
		const subdistrictValues = params.subdistrict.split(',');
		updateFilters({
			subdistrict: subdistrictValues.some((/** @type {string} */x) =>
				Object.keys(dictionaries.locations.subdistricts[params.city]).includes(x)
			)
				? subdistrictValues.map((/** @type {string} */x) => dictionaries.locations.subdistricts[params.city][x])
				: []
		});
	}

	return filters;
}
